import React from 'react'
import moment from 'moment-timezone'
import 'moment/locale/en-gb'
import 'moment/locale/et'
import 'moment/locale/sv'
import 'moment/locale/fi'
// import { Row, Col } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { Button, Divider, Typography } from '@material-ui/core'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect} from 'react-redux-firebase'
import withAppconfig from '../../AppContext'
import { getPosterUrl } from '../ViewUtils'
import { ChevronRight } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'

const notHappen = (x, gtime) => {
  const entryPast = moment.utc(x.entryend).isBefore(gtime)
  const noParticipants = x.participants && x.participants.length === 0
  // const notEnoughtParticipants = x.participants && x.participants.length < x.minp
  const missingParticipantsData = !x.participants
  return entryPast && (noParticipants || missingParticipantsData)
}

const mapStateToProps = (state, props) => {
  const {
    globaltime: { gtime },
    firebase,
  } = state
  const memberships = []
  if (firebase.ordered.shopmemberships) {
    firebase.ordered.shopmemberships.forEach((m) => {
      memberships.push({ id: m.key, ...m.value })
    })
  }
  if (
    firebase.data.activities &&
    firebase.data.activities[props.appconfig.accountkey]
  ) {
    const _activities = JSON.parse(
      JSON.stringify(firebase.data.activities[props.appconfig.accountkey])
    )
    const activities = []
    // const types = [] //[{ value: 'all', label: 'Kaikki' }]
    // const sports = []
    for (let a in _activities) {
      const durationindays = moment
        .utc(_activities[a].end, 'YYYY-MM-DDTHH:mm')
        .startOf('day')
        .diff(
          moment.utc(_activities[a].start, 'YYYY-MM-DDTHH:mm').startOf('day'),
          'days',
          false
        )
      _activities[a].durationindays = durationindays
      activities.push({ id: a, ..._activities[a] })
      // const isAlreadyIn = types.find(
      //   (t) => t.value === _activities[a].type.toLowerCase()
      // )
      // const isAlreadySport = sports.find(
      //   (t) =>
      //     _activities[a].sport && t.value === _activities[a].sport.toLowerCase()
      // )
      // if (!isAlreadyIn) {
      //   types.push({
      //     value: _activities[a].type.toLowerCase(),
      //     label: _activities[a].type,
      //   })
      // }
      // if (!isAlreadySport) {
      //   if (_activities[a].sport) {
      //     const capFirst =
      //       _activities[a].sport.toLowerCase().charAt(0).toUpperCase() +
      //       _activities[a].sport.toLowerCase().slice(1)
      //     sports.push({
      //       value: _activities[a].sport.toLowerCase(),
      //       label: capFirst,
      //     })
      //   }
      // }
    }
    // if (types.length > 1) {
    //   types.unshift({ value: 'all', label: 'Kaikki', t: 'all' })
    // }
    // if (sports.length > 1) {
    //   sports.unshift({ value: 'all', label: 'Kaikki', t: 'all' })
    // }

    const __activities = activities
      .filter((x) => x.state === 'published')
      .filter((x) => {
        if (x.durationindays) {
          return x.durationindays < 3
        } else {
          return true
        }
      })
      .filter((x) => !notHappen(x, gtime))
      .filter((x) => {
        if (x.entryend) {
          return gtime.isSameOrBefore(
            moment
              .utc(x.entryend, 'YYYY-MM-DDTHH:mm')
              .subtract(moment().tz('Europe/Helsinki').utcOffset(), 'minutes')
          )
        } else {
          return true
        }
      })
      .filter((x) => {
        if (x.start) {
          return moment
            .utc(x.start, 'YYYY-MM-DDTHH:mm')
            .subtract(moment().tz('Europe/Helsinki').utcOffset(), 'minutes')
            .isAfter(gtime)
        } else {
          return true
        }
      })
      .filter((x) =>
        moment
          .utc(x.end, 'YYYY-MM-DDTHH:mm')
          .subtract(moment().tz('Europe/Helsinki').utcOffset(), 'minutes')
          .isAfter(gtime)
      )
      .sort((a, b) => {
        if (a.start < b.start) {
          return -1
        }
        if (a.start > b.start) {
          return 1
        }
        return 0
      })
      .sort((a, b) => {
        if (a.pinned && !b.pinned) {
          return -1
        }
        if (!a.pinned && b.pinned) {
          return 1
        }
        return 0
      })

    return {
      activities: __activities,
      gtime,
      memberships,
    }
  } else {
    return {
      activities: [],
      gtime,
      memberships,
    }
  }
}

const withActivationItems = compose(
  connect((state) => ({ auth: state.firebase.auth })),
  firebaseConnect((props) => [
    {
      path: 'activities/' + props.appconfig.accountkey,
      queryParams: ['orderByChild=displayName'],
    },
    {
      path: 'shop/' + props.appconfig.accountkey + '/memberships',
      queryParams: ['orderByChild=displayName'],
      storeAs: 'shopmemberships',
    },
  ]),
  connect(mapStateToProps)
)

const ActivityLine = ({ activity, appconfig }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const starttime = moment(activity.start).locale(t('lang'))
  const endtime = moment(activity.end).locale(t('lang'))
  const timeformatStart = 'dd D.M.YY H:mm'
  const timeformat = 'H:mm'
  console.log(activity)
  const imageUrl = getPosterUrl(activity.poster, 60)
  console.log(imageUrl)
  return (
    <div
      style={{ marginBottom: 10, cursor: 'pointer' }}
      onClick={() =>
        history.push(appconfig.pathPrefix + '/activities/' + activity.id)
      }
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={activity.displayName}
          style={{
            float: 'left',
            marginTop: 5,
            marginRight: 5,
            width: 35,
            height: 35,
            objectFit: 'cover',
          }}
        />
      ) : null}
      <Typography variant='subtitle2'>{activity.displayName}</Typography>
      <Typography variant='body2' color='textSecondary'>
        {starttime.format(timeformatStart)} - {endtime.format(timeformat)}
      </Typography>
    </div>
  )
}

const MembershipLine = ({ membership, appconfig }) => {
  // const { t } = useTranslation()
  const history = useHistory()
  let price = ''
  if (membership.variations && membership.variations.length > 0) {
    price =
      (membership.variations[0].price / 100).toFixed(2).replace('.', ',') + ' €'
  }
  const imageUrl = getPosterUrl(membership.poster, 60)
  return (
    <div
      style={{ marginBottom: 10, cursor: 'pointer' }}
      onClick={() =>
        history.push(appconfig.pathPrefix + '/shop/membership/' + membership.id)
      }
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={membership.displayName}
          style={{
            float: 'left',
            marginTop: 5,
            marginRight: 5,
            width: 35,
            height: 35,
            objectFit: 'cover',
          }}
        />
      ) : null}
      <Typography variant='subtitle2'>{membership.displayName}</Typography>
      <Typography variant='body2' color='textSecondary'>
        {price}
      </Typography>
    </div>
  )
}

const MembershipPart = ({ memberships, appconfig, divider }) => {
  const { t } = useTranslation()
  const history = useHistory()
  return (
    <>
      {divider ? <Divider style={{ marginTop: 10, marginBottom: 10 }} /> : null}
      <Typography
        variant='button'
        gutterBottom
        style={{ marginTop: 10, fontWeight: 'bold' }}
      >
        {t('available_memberships')}
      </Typography>
      {appconfig.memberships && memberships && memberships.length > 0
        ? memberships
            .slice(0, 3)
            .map((membership) => (
              <MembershipLine
                key={membership.id}
                membership={membership}
                appconfig={appconfig}
              />
            ))
        : null}
      {appconfig.memberships && memberships.length > 3 ? (
        <Button
          size='small'
          variant='text'
          endIcon={<ChevronRight />}
          onClick={() => history.push(appconfig.pathPrefix + '/shop/memberships')}
        >
          {t('activation_banner_activities_show_more')}
        </Button>
      ) : null}
    </>
  )
}

const ActivitiesPart = ({ activities, appconfig }) => {
  const { t } = useTranslation()
  const history = useHistory()
  return (
    <>
      <Typography
        variant='button'
        gutterBottom
        style={{ marginTop: 10, fontWeight: 'bold' }}
      >
        {t('activation_banner_activities_title')}
      </Typography>
      {activities && activities.length > 0
        ? activities
            .slice(0, 3)
            .map((activity) => (
              <ActivityLine
                key={activity.id}
                activity={activity}
                appconfig={appconfig}
              />
            ))
        : null}
      {activities && activities.length > 3 ? (
        <Button
          size='small'
          variant='text'
          endIcon={<ChevronRight />}
          onClick={() => history.push(appconfig.pathPrefix + '/activities/all')}
        >
          {t('activation_banner_activities_show_more')}
        </Button>
      ) : null}
    </>
  )
}

const ActivationBanner = ({ activities, appconfig, memberships }) => {
  return (
    <>
      {appconfig.activities && activities && activities.length > 0 ? (
        <ActivitiesPart activities={activities} appconfig={appconfig} />
      ) : null}
      {appconfig.memberships && memberships && memberships.length > 0 ? (
        <MembershipPart memberships={memberships} appconfig={appconfig} divider={appconfig.activities && activities && activities.length > 0} />
      ) : null}
    </>
  )
}
export default withAppconfig(withActivationItems(ActivationBanner))
